/**
 * Timing-warning list for an itinerary stop card — the cross-stop warnings
 * computed at the day level merged with the per-stop venue-hours warning.
 *
 * Extracted verbatim from `ItineraryStopCard` (#314). Renders nothing when the
 * warning set is empty.
 */

import type { StopWarning } from './stopTiming';

interface StopWarningsListProps {
  warnings: StopWarning[];
}

export const StopWarningsList = ({ warnings }: StopWarningsListProps) => {
  if (warnings.length === 0) return null;

  return (
    <ul className="mt-2 space-y-1" aria-label="Timing issues">
      {warnings.map((w, i) => (
        <li
          key={i}
          className="flex items-start gap-1.5 rounded-md border border-amber-200 bg-amber-50/80 px-2 py-1 text-[0.78rem] leading-tight text-amber-900"
          role={w.severity === 'warning' ? 'alert' : undefined}
        >
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            className="mt-[2px] h-3.5 w-3.5 shrink-0 text-amber-700"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M8.485 2.495a1.75 1.75 0 013.03 0l6.28 10.875A1.75 1.75 0 0116.28 16H3.72a1.75 1.75 0 01-1.515-2.63L8.485 2.495zM10 6.75a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3A.75.75 0 0110 6.75zm0 6.25a.875.875 0 100 1.75.875.875 0 000-1.75z"
              clipRule="evenodd"
            />
          </svg>
          <span>{w.message}</span>
        </li>
      ))}
    </ul>
  );
};
